import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ZoomIn from '@material-ui/icons/ZoomIn';
import ZoomOut from '@material-ui/icons/ZoomOut';
import Fullscreen from '@material-ui/icons/Fullscreen';
import Mouse from '@material-ui/icons/MouseOutlined';
import DownIcon from '@material-ui/icons/CloudDownload';
import parse from 'html-react-parser';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

import Device from '../../utils/DeviceInfos';
import Container from '../../containers/Container';
import schema from '../../res/schema_compress.jpg';
import styles from './styles';

const BASE_URL = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? '' : process.env.PUBLIC_URL;

class HomeGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = { wheel: false };
    this.toogleWheel = this.toogleWheel.bind(this);
  }

  toogleWheel() {
    this.setState(prevState => ({ wheel: !prevState.wheel }));
  }

  render() {
    const { wheel } = this.state;
    const { classes, data } = this.props;
    const { graph: block } = data.home;
    return (
      <Container className={classes.container} id="home-graph">
        <Typography variant="h2" className={classes.title}>
          {parse(block.title)}
        </Typography>
        <div className={classes.wrapperContainer}>
          <TransformWrapper wheel={{ disabled: !wheel }}>
            {({ zoomIn, zoomOut, resetTransform }) => (
              <>
                <TransformComponent>
                  <img src={schema} alt="test" className={classes.image} />
                </TransformComponent>
                <div className={classes.toolsContainer}>
                  <IconButton onClick={zoomIn} title={block['tooltip-zoom-in']}>
                    <ZoomIn />
                  </IconButton>
                  <IconButton onClick={zoomOut} title={block['tooltip-zoom-out']}>
                    <ZoomOut />
                  </IconButton>
                  <IconButton onClick={resetTransform} title={block['tooltip-reset']}>
                    <Fullscreen />
                  </IconButton>
                  {Device.device.type !== 'smartphone' && Device.device.type !== 'tablet' ? (
                    <IconButton onClick={this.toogleWheel} title={block['tooltip-mouse']}>
                      <Mouse color={wheel ? 'primary' : 'inherit'} />
                    </IconButton>
                  ) : null}
                  <IconButton
                    target="_blank"
                    component="a"
                    download
                    href={`${BASE_URL}/${block['schema-url']}`}
                    title={block['tooltip-download']}
                  >
                    <DownIcon />
                  </IconButton>
                </div>
              </>
            )}
          </TransformWrapper>
        </div>
        <div></div>
      </Container>
    );
  }
}

HomeGraph.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HomeGraph);
